import { c as _c } from "react/compiler-runtime";
import type { ListRecommendPolicyDto } from '__generated__/api/auth';
import { cn } from '@core/utils';
import Link from 'next/link';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { getDdayColorClass, getDdayText, parseDday } from '../_lib/utils';
import { BookmarkButton } from './BookmarkButton';
interface CardProps {
  policy: ListRecommendPolicyDto;
  isLast?: boolean;
}
export const Card = t0 => {
  const $ = _c(72);
  const {
    policy
  } = t0;
  let T0;
  let parsedDday;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== policy.agency || $[1] !== policy.agencyLogo || $[2] !== policy.aiSummary || $[3] !== policy.dday || $[4] !== policy.dueDateEnd || $[5] !== policy.id || $[6] !== policy.metaPolicyIdIdx || $[7] !== policy.newPolicy || $[8] !== policy.policyName || $[9] !== policy.slugId || $[10] !== policy.wishlistCount || $[11] !== policy.wishlistYN) {
    parsedDday = parseDday(policy.dday);
    T0 = Link;
    if ($[22] !== policy.metaPolicyIdIdx || $[23] !== policy.slugId) {
      t7 = ROUTES.POLICY_DETAIL.withSearchParams({
        dynamicPath: {
          idIdx: policy.slugId ?? policy.metaPolicyIdIdx
        }
      });
      $[22] = policy.metaPolicyIdIdx;
      $[23] = policy.slugId;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    t8 = "block";
    t5 = "flex flex-col gap-16 rounded-xxlarge bg-Gray-white p-24";
    let t9;
    if ($[25] !== policy.agency || $[26] !== policy.agencyLogo) {
      t9 = <Image src={policy.agencyLogo} alt={policy.agency} width={20} height={20} className="size-20 rounded-pill border-1 border-Gray-300" />;
      $[25] = policy.agency;
      $[26] = policy.agencyLogo;
      $[27] = t9;
    } else {
      t9 = $[27];
    }
    let t10;
    if ($[28] !== policy.agency) {
      t10 = <span className="font-600 text-Gray-500 typo-caption1">{policy.agency}</span>;
      $[28] = policy.agency;
      $[29] = t10;
    } else {
      t10 = $[29];
    }
    let t11;
    if ($[30] !== t10 || $[31] !== t9) {
      t11 = <div className="flex items-center gap-4">{t9}{t10}</div>;
      $[30] = t10;
      $[31] = t9;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    let t12;
    if ($[33] !== policy.newPolicy) {
      t12 = policy.newPolicy && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2 ml-4 inline-block shrink-0 align-middle"><rect width="16" height="16" rx="8" className="fill-O-500" /><path d="M10.95 4.43V11.5H9.68L6.57 7.01H6.52V11.5H5.05V4.43H6.34L9.43 8.92H9.49V4.43H10.95Z" className="fill-Gray-white" /></svg>;
      $[33] = policy.newPolicy;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t13;
    if ($[35] !== policy.policyName || $[36] !== t12) {
      t13 = <h3 className="line-clamp-2 max-w-[90%] break-words font-600 text-Gray-black transition-colors typo-body3 group-hover:text-Gray-600">{policy.policyName}{t12}</h3>;
      $[35] = policy.policyName;
      $[36] = t12;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    let t14;
    if ($[38] !== t11 || $[39] !== t13) {
      t14 = <div className="group flex flex-1 flex-col gap-6">{t11}{t13}</div>;
      $[38] = t11;
      $[39] = t13;
      $[40] = t14;
    } else {
      t14 = $[40];
    }
    let t15;
    if ($[41] !== policy.agency || $[42] !== policy.id || $[43] !== policy.policyName || $[44] !== policy.wishlistCount || $[45] !== policy.wishlistYN) {
      t15 = <BookmarkButton policyId={policy.id} policyName={policy.policyName} agency={policy.agency} isBookmarked={policy.wishlistYN} bookmarkCount={policy.wishlistCount} />;
      $[41] = policy.agency;
      $[42] = policy.id;
      $[43] = policy.policyName;
      $[44] = policy.wishlistCount;
      $[45] = policy.wishlistYN;
      $[46] = t15;
    } else {
      t15 = $[46];
    }
    if ($[47] !== t14 || $[48] !== t15) {
      t6 = <div className="flex items-start justify-between">{t14}{t15}</div>;
      $[47] = t14;
      $[48] = t15;
      $[49] = t6;
    } else {
      t6 = $[49];
    }
    t3 = "flex flex-col gap-16";
    if ($[50] !== policy.aiSummary) {
      t4 = policy.aiSummary && <div className="rounded-small bg-Gray-25 px-14 py-12"><p className="line-clamp-2 font-400 text-Gray-600 typo-caption1"><span className="mb-2 mr-2 inline-flex items-center gap-2 whitespace-nowrap align-middle"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0"><defs><linearGradient id="ai-gradient-card" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="rotate(125.96)"><stop offset="0%" stopColor="#33A6FF" /><stop offset="100%" stopColor="#6A00FF" /></linearGradient></defs><path d="M7.89 5.29C7.67 5.2 7.5 5.02 7.41 4.81L6.7 3.19C6.56 2.94 6.18 2.94 6.05 3.19L5.34 4.81C5.24 5.02 5.07 5.19 4.86 5.29L3.95 5.68C3.68 5.81 3.68 6.18 3.95 6.31L4.86 6.7C5.08 6.79 5.25 6.97 5.34 7.18L6.05 8.81C6.19 9.06 6.57 9.06 6.7 8.81L7.41 7.18C7.51 6.97 7.68 6.8 7.89 6.7L8.8 6.31C9.07 6.18 9.07 5.81 8.8 5.68L7.89 5.29Z" fill="url(#ai-gradient-card)" /><path d="M19.18 10.166C18.53 9.88 18.01 9.34 17.74 8.68L15.59 3.61C15.2 2.8 14.05 2.8 13.66 3.61L11.51 8.68C11.23 9.34 10.71 9.88 10.07 10.166L7.35 11.4C6.55 11.79 6.55 12.96 7.35 13.35L10.07 14.584C10.72 14.87 11.24 15.41 11.51 16.07L13.66 21.14C14.05 21.95 15.2 21.95 15.59 21.14L17.74 16.07C18.02 15.41 18.54 14.87 19.18 14.584L21.9 13.35C22.701 12.96 22.701 11.79 21.9 11.4L19.18 10.166Z" fill="url(#ai-gradient-card)" /><path d="M6.21 15.25C6.33 15.54 6.55 15.77 6.83 15.9L7.99 16.45C8.34 16.62 8.34 17.13 7.99 17.3L6.83 17.85C6.55 17.98 6.33 18.22 6.21 18.5L5.29 20.74C5.12 21.09 4.63 21.09 4.46 20.74L3.54 18.5C3.42 18.21 3.2 17.98 2.92 17.85L1.76 17.3C1.41 17.13 1.41 16.62 1.76 16.45L2.92 15.9C3.2 15.77 3.42 15.53 3.54 15.25L4.46 13.01C4.63 12.66 5.12 12.66 5.29 13.01L6.21 15.25Z" fill="url(#ai-gradient-card)" /></svg><span className="bg-clip-text font-700 text-transparent typo-caption1" style={{
              background: "linear-gradient(125.96deg, #33A6FF -8.28%, #6A00FF 101.68%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}>AI 요약</span></span>{" "}{policy.aiSummary}</p></div>;
      $[50] = policy.aiSummary;
      $[51] = t4;
    } else {
      t4 = $[51];
    }
    t1 = "flex items-center gap-12";
    t2 = parsedDday !== undefined && <span className={cn("font-600 typo-caption1", getDdayColorClass(parsedDday))}>{parsedDday === -1 && policy.dueDateEnd ? `${policy.dueDateEnd} 마감` : getDdayText(parsedDday)}</span>;
    $[0] = policy.agency;
    $[1] = policy.agencyLogo;
    $[2] = policy.aiSummary;
    $[3] = policy.dday;
    $[4] = policy.dueDateEnd;
    $[5] = policy.id;
    $[6] = policy.metaPolicyIdIdx;
    $[7] = policy.newPolicy;
    $[8] = policy.policyName;
    $[9] = policy.slugId;
    $[10] = policy.wishlistCount;
    $[11] = policy.wishlistYN;
    $[12] = T0;
    $[13] = parsedDday;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    T0 = $[12];
    parsedDday = $[13];
    t1 = $[14];
    t2 = $[15];
    t3 = $[16];
    t4 = $[17];
    t5 = $[18];
    t6 = $[19];
    t7 = $[20];
    t8 = $[21];
  }
  let t9;
  if ($[52] !== parsedDday || $[53] !== policy.daysAgo) {
    t9 = policy.daysAgo && parsedDday !== -1 && <span className="ml-auto font-600 text-Gray-500 typo-caption1">{policy.daysAgo}</span>;
    $[52] = parsedDday;
    $[53] = policy.daysAgo;
    $[54] = t9;
  } else {
    t9 = $[54];
  }
  let t10;
  if ($[55] !== t1 || $[56] !== t2 || $[57] !== t9) {
    t10 = <div className={t1}>{t2}{t9}</div>;
    $[55] = t1;
    $[56] = t2;
    $[57] = t9;
    $[58] = t10;
  } else {
    t10 = $[58];
  }
  let t11;
  if ($[59] !== t10 || $[60] !== t3 || $[61] !== t4) {
    t11 = <div className={t3}>{t4}{t10}</div>;
    $[59] = t10;
    $[60] = t3;
    $[61] = t4;
    $[62] = t11;
  } else {
    t11 = $[62];
  }
  let t12;
  if ($[63] !== t11 || $[64] !== t5 || $[65] !== t6) {
    t12 = <article className={t5}>{t6}{t11}</article>;
    $[63] = t11;
    $[64] = t5;
    $[65] = t6;
    $[66] = t12;
  } else {
    t12 = $[66];
  }
  let t13;
  if ($[67] !== T0 || $[68] !== t12 || $[69] !== t7 || $[70] !== t8) {
    t13 = <T0 href={t7} className={t8}>{t12}</T0>;
    $[67] = T0;
    $[68] = t12;
    $[69] = t7;
    $[70] = t8;
    $[71] = t13;
  } else {
    t13 = $[71];
  }
  return t13;
};